var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popper',{attrs:{"trigger":_vm.trigger,"options":{
    placement: 'top',
  }}},[_c('div',{staticClass:"popper bg-whiteOverride border-whiteOverride p-base shadow-popper",attrs:{"data-test":"popper-content"}},[_vm._t("popper-content")],2),_vm._t("reference",null,{"slot":"reference"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }